var React = require('react');

function Coupon (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Icon/coupon"},React.createElement("path",{"id":"Icon Stroke","d":"M10 9.25V7.75M10 16.25V14.75M10 12.75V11.25M16.25 14.5V15.5M16.25 8.5V9.5M17.5438 10.1667C17.2845 9.83333 16.8956 9.5 16.2475 9.5C15.5993 9.5 14.9512 9.91667 14.9512 10.75C14.9512 11.5833 15.6008 11.9169 16.2475 12C16.8956 12.0833 17.5438 12.4167 17.5438 13.25C17.5438 14.0833 16.8956 14.5 16.2475 14.5C15.5993 14.5 15.2104 14.1667 14.9512 13.8333M10 7.5C10.8284 7.5 11.5 6.82843 11.5 6H21.5V18H11.5C11.5 17.1716 10.8284 16.5 10 16.5C9.17157 16.5 8.5 17.1716 8.5 18H2.5V6H8.5C8.5 6.82843 9.17157 7.5 10 7.5Z","stroke":"#00121A","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"})));
}

Coupon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Coupon;

Coupon.default = Coupon;
